import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/d/src/uu-data-dict/uu-data-dict/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "er-mist-een-onderwerp"
    }}>{`Er mist een onderwerp`}</h1>
    <p>{`Heb je een vraag die hier niet terug te vinden is?`}</p>
    <p>{`Laat het weten `}<a parentName="p" {...{
        "href": "https://uurwerk.zendesk.com/"
      }}>{`via je helpdesk`}</a>{`. We helpen je graag verder!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      